export function v3ToV4(_registry, v3) {
    return v3;
}
